<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content
			:title="page.title || page.header"
			:content="page.content"
			:subtitle="page.subtitle"
			:booking-id="page.bookingID"
		/>

		<section class="main-content faq-main-content align-center">
			<frequently-asked-questions v-for="faq in faqs" :key="faq.ID" :items="faq.faqitems" :header="faq.header" />
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<pre-footer v-if="page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/faqs`,
});
</script>

<style lang="scss" scoped>
.faq-main-content {
	padding-bottom: 0;
}
</style>
